export default {
  'payout.title': '刷卡手续费报表',
  'payout.summary.totalSubmittedCharges': '刷卡交易总额',
  'payout.summary.totalSettledCharges': '总结算金额',
  'payout.summary.totalSettledCharges.description':
    '结算一般晚于提交时间、结算后如有退款等，都会导致结算金额可能不等于提交金额。',
  'payout.summary.totalTransactionsSettled': '总结算笔数',
  'payout.summary.totalFees': '总交易扣费',
  'payout.summary.totalTransaction': '总交易额',
  'payout.section.settledCharges.title': '结算金额',
  'payout.section.totalChanges.title': '总金额',
  'payout.section.settledCharges.summary': '总金额',
  'payout.section.transactionsSettled.title': '结算笔数',
  'payout.section.transactionsSettled.summary': '总笔数',
  'payout.section.feeTypes.title': '费用类型',
  'payout.section.feeTypes.totalFees': '总扣费',
  'payout.section.feeTypes.networkFees': 'Network Fees',
  'payout.section.transactionFee': '刷卡手续扣费',
  'payout.section.payoutByDate': '每日打款统计',
  'payout.section.payoutAdjustment': '打款调整',
  'payout.section.payoutTransaction': '返还',
  'payout.column.date': '订单日期',
  'payout.column.payout_range': '打款区间',
  'payout.column.payout_date': '打款日期',
  'payout.column.payment_count': '刷卡交易笔数',
  'payout.column.payment_amount': '刷卡交易金额',
  'payout.column.refund': '拒付 / 退单金额',
  'payout.column.adjustment': '调整金额',
  'payout.column.adjustment_tip': '小费调整',
  'payout.column.transaction_fee': '刷卡手续扣费',
  'payout.column.transaction_fee.description': '该扣费只针对于固定费率。',
  'payout.column.amount': '实际打款金额',
  'payout.column.state': '打款状态',
  'payout.transaction.order_date': '交易日期',
  'payout.transaction.charge_date': '打款日期',
  'payout.transaction.network_and_gateway_fees': 'Network & Gateway Fees',
  'payout.transaction.chowbus_processing_fee': 'Chowbus Processing Fee',
  'payout.transaction.chowbus_processing_fee.tooltip':
    'Chowbus Processing Fee is computed as the credit card processing fees charged by Chowbus minus any processing rebate.',
  'payout.transaction.transaction_fee': '刷卡手续扣费',
  'payout.adjustment.chargeDate': '扣款日期',
  'payout.adjustment.date': '日期',
  'payout.adjustment.itemName': '调整名称',
  'payout.adjustment.amount': '金额',
  'payout.adjustment.notes': '备注',
};
